<forge-card class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
            <truncate-text *ngIf="isLoaded" fxFlex="100" [allowHtml]="true" [mainText]="ChartSubtitle"
                           class="forge-typography--subheading1">
            </truncate-text>
        </div>

        <forge-icon-button slot="end" (click)="openSettings()" tabindex="0" class="chart-settings"
                           telemetry="Chart settings" aria-haspopup="true" aria-label="chart settings">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </forge-toolbar>

    <div class="metadata-padding">
        <div *ngIf="isLoaded">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>

            <div *ngIf="!showChart">
                Not enough data to display graph
            </div>

            <div *ngIf="errorMessage" class="error-red">
                {{errorMessage}}
            </div>
        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>

        <div *ngIf="isLoaded" fxLayout="row" fxLayoutAlign="end center">
            <command-bar [commands]="commands" telemetry="Menu-GenericChart"></command-bar>
        </div>
    </div>
</forge-card>
